import React from 'react';
import SavingIcon from '../../../assets/svg/savings-logo';

interface PromoCodeBadgeProps {
  promoCodes: string[];
  handleRemove: (_code: string) => void;
  loading: boolean;
}

export const PromoCodeBadge: React.FC<PromoCodeBadgeProps> = ({
  loading,
  promoCodes,
  handleRemove,
}) => {
  return (
    <>
      <div className="mt-4 flex flex-col space-y-2">
        {promoCodes?.map(code => (
          <div key={code} className="inline-flex">
            <span className="flex flex-row items-center gap-x-0.5 rounded-md px-2 py-1 text-sm font-bold bg-gray-500/10 text-gray-600 ring-1 ring-inset ring-gray-500/10">
              <SavingIcon className="h-4 w-4 mr-1 text-gray-700" />
              {code}
              <button
                type="button"
                className="group relative -mr-1 h-5 w-5 rounded-sm hover:bg-gray-500/20"
                onClick={() => handleRemove(code)}
                disabled={loading}>
                <span className="sr-only">Remove</span>
                <svg
                  viewBox="0 0 14 14"
                  className="h-5 w-5 stroke-gray-600/50 group-hover:stroke-gray-600/75">
                  <path d="M4 4l6 6m0-6l-6 6" />
                </svg>
                <span className="absolute -inset-1" />
              </button>
            </span>
          </div>
        ))}
      </div>
    </>
  );
};
